<template>
    <main class="page page-dashboard">
        <div class="container">

            <PageHeader
                :title="$translate.text('general.attributes')"
            />

            <ConnectionMenu></ConnectionMenu>

            <form @submit.prevent="submitForm" method="POST">
                <h4>{{ t('general.general_information') }}</h4>

                <div class="form-group">
                    <label for="brands">{{ $translate.text('general.brands') }}
                        <i style="font-size: 14px;"></i>
                    </label>

                    <Multiselect
                        v-model="attribute.brands"
                        :options="brandsSelectValues"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :placeholder="this.$translate.text('general.select_all')"
                        label="label"
                        track-by="value"
                        open-direction="bottom"
                        id="brands"
                    >
                        <!-- <template slot="selection" open-direction="bottom" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
                    </Multiselect>
                </div>

                <div class="form-group">
                    <label for="categories">{{ $translate.text('general.categories') }}
                        <i style="font-size: 14px;"></i>
                    </label>

                    <Multiselect
                        v-model="attribute.categories"
                        :options="categoriesSelectValues"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :placeholder="this.$translate.text('general.select_all')"
                        label="label"
                        track-by="value"
                        open-direction="bottom"
                        id="categories"
                    >
                        <!-- <template slot="selection" open-direction="bottom" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
                    </Multiselect>
                </div>

                <Select
                    id="property_group"
                    :value="attribute.property_group"
                    name="property_group"
                    @change="propertyGroupChanged($event)"
                    :options="groupsSelectValues"
                    :label="$translate.text('general.product_group')"
                    :required="true"
                    :loading="!groupsLoaded"
                />

                <!-- Update 282-->
                <div v-if="selectedAttribute">
                    <div class="row" >
                        <div class="col-sm-3">
                            <h4>{{ t('client.feeds.combine.combine') }}</h4>
                        </div>
                        <div class="col-sm"></div>
                        <div class="col-sm">
                            <h4>{{ t('client.feeds.combine.draganddrop') }}</h4>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-8" style="display:flex; overflow: auto; height: 700px; padding: 0px;">
                            <div class="col-sm-4">

                                <input type="text" v-model="search_combinable" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                                <div v-for="(item, index) in combinableValues" :key="index" class="list-group-item list-group-item--header" :style="{'height': `${(37 * item.placeholders.length) + (10 * (item.placeholders.length-1))}px`}">
                                    {{ item.name }}
                                    <span v-if="item.required">*</span>
                                    <i class="fal fa-plus pointer" style="float:right;" @click="appendPlaceholder(index)" v-tooltip.bottom="$translate.text('tooltip.append')"></i>
                                </div>
                            </div>
                            <div class="col-sm-8">

                                <div style="height: 47px;">&nbsp;</div>

                                <template v-for="(item, itemIndex) in combinableValues">
                                    <drop
                                        class="drop list-group-item list-group-item--drop"
                                        v-for="(placeholder, placeholderIndex) in item.placeholders"
                                        :key="`labels-${itemIndex}-placeholders-${placeholderIndex}`"
                                        :class="{'list-group-item--targeted': placeholder.hovered, 'list-group-item--holder': placeholder.value === ''}"
                                        @drop="dropHandle($event, itemIndex, placeholderIndex)"
                                        @dragenter="dragEnter(itemIndex, placeholderIndex)"
                                        @dragleave="dragLeave(itemIndex, placeholderIndex)"
                                    >
                                        <input v-tooltip.top="$translate.text('clients.connections.attributes.use_as_variant')" type="checkbox" v-if="placeholder.value !== '' && connection.use_variants === 1" :disabled="item.placeholders.filter(h => h.value !== '').length > 1"v-model="placeholder.use_as_variant" >
                                        {{ placeholder.value }}
                                        <i class="fal fa-trash-alt pointer" v-if="placeholder.value !== ''" style="float:right;" @click="dropClear(itemIndex, placeholderIndex)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                    </drop>
                                </template>
                            </div>
                        </div>
                        <div class="col-sm" style="overflow: auto;height: 700px;">

                            <input type="text" v-model="search" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                            <drag
                                class="drag list-group-item list-group-item--drag"
                                v-for="(item, index) in uncombinedValues"
                                :key="index"
                                :transfer-data="item.key"
                            >
                                <i class="fal fa-arrows"></i> {{ item.key }}
                                <i class="fal fa-eye" v-tooltip.top="$translate.text('general.example') + `: ` + item.example" :popoverInnerClass="`tooltip-inner-boxed`"></i>
                            </drag>
                        </div>
                    </div>

                </div>
                <!-- end update 282 -->

                <FormSubmit
                    :routeAfterCancelLink="{ name: 'Clients Connections Attributes' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                    :disabled="submittingIsLoading"
                />
            </form>
        </div>
    </main>
</template>
<script>
import Multiselect from 'vue-multiselect';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'ClientAddAttribute',

    components: {
        ConnectionMenu,
        PageHeader,
        Select,
        FormSubmit,
        Multiselect,
    },

    data() {
        return {

            search_combinable: '',
            search: '',

            attribute: {
                brand_id: null,
                category_id: null,
                categories: [],
                property_group: null,
                value: null,
                feed_name: null,
            },

            submittingIsLoading: false,

            connection: [],
            connectionLoaded: false,

            webshopcategories: [],
            webshopcategoriesLoaded: false,

            brands: [],
            brandsLoaded: false,

            categories: [],
            categoriesLoaded: false,

            groups: [],
            groupsLoaded: false,

            values: [],
            valuesLoaded: false,

            feedvalues: [],
            feedValuesLoaded: false,
        };
    },

    created() {
        this.getConnection();
    },

    methods: {
        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data;

                    connection.active = connection.active === 1;
                    connection.vat_calculate = connection.vat_calculate === 1;
                    connection.content_provider.active = connection.content_provider.active === 1;

                    this.connection = connection;

                    this.connectionLoaded = true;

                    this.getCombinedBrands();
                    this.getCombinedCategories();
                    this.getWebshopCategories();
                    this.getProductgroups();
                    this.getFeedvalues();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedBrands() {
            this.API.clients.connections.brands.getCombined(this.$route.params.id)
                .then(response => {
                    this.brands = response.data.data;
                    this.brandsLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedCategories() {
            this.API.clients.connections.categories.getCombined(this.$route.params.id)
                .then(response => {
                    this.categories = response.data.data;
                    this.categoriesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getWebshopCategories() {
            if (this.connection.configbase === 'webshop') {
                this.API.clients.connections.categories.getItemsFromWebshop(this.connection.id)
                    .then(response => {
                        this.webshopcategories = response.data;
                        this.webshopcategoriesLoaded = true;
                    }).catch(error => {
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            } else {
                this.webshopcategoriesLoaded = true;
            }
        },

        getProductgroups() {
            this.API.clients.connections.attributes.getProductgroups(this.$route.params.id)
                .then(response => {
                    this.groups = response.data;
                    this.groupsLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getAttributes() {
            if (this.attribute.property_group !== null) {
                this.API.clients.connections.attributes.getAttributes(this.$route.params.id, this.attribute.property_group)
                    .then(response => {
                        const data = response.data;
                        Object.keys(data).forEach(index => {
                            data[index].placeholders = [];
                            data[index].placeholders.push({
                                hovered: false,
                                value: '',
                                use_as_variant: false,
                            });
                        });
                        this.values = data;
                        this.valuesLoaded = true;
                    }).catch(error => {
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            } else {
                this.values = [];
                this.valuesLoaded = true;
            }
        },

        getFeedvalues() {
            this.API.clients.feeds.combine.attributes(this.connection.feed_id)
                .then(response => {
                    this.feedvalues = response.data;
                    this.feedValuesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;

            const combines = [];
            this.values.forEach(value => {
                value.placeholders.forEach(placeholder => {
                    if (placeholder.value !== '') {
                        combines.push({
                            value: value.id,
                            feed_name: placeholder.value,
                            use_as_variant: placeholder.use_as_variant,
                        });
                    }
                });
            });
            this.attribute.attribute = combines;

            this.API.clients.connections.attributes.store(this.$route.params.id, this.attribute)
                .then(() => {
                    this.submittingIsLoading = false;
                    this.$router.push({ name: 'Clients Connections Attributes' });
                    this.resetForm();
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resetForm() {
            this.attribute = {
                brand_id: null,
                category_id: null,
                property_group: null,
                value: null,
                feed_name: null,
            };
        },

        propertyGroupChanged(newValue) {
            this.attribute.property_group = newValue !== null ? parseInt(newValue, 10) : null;
            this.getAttributes();
        },

        dropHandle(data, itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = data;
        },

        dropClear(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = '';
            this.combinableValues[itemIndex].placeholders[placeholderIndex].use_as_variant = false;
        },

        dragEnter(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = true;
        },

        dragLeave(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
        },

        appendPlaceholder(index) {
            this.combinableValues[index].placeholders.push({
                hovered: false,
                value: '',
                use_as_variant: false,
            });
        },

        findCategoryNameById(categories, id, name = null) {
            categories.forEach(category => {
                if (category.id === id) {
                    name = category.name;
                }

                if (category.children) {
                    name = this.findCategoryNameById(category.children, id, name);
                }
            });

            return name;
        },

    },

    computed: {
        brandsSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_all'), value: null },
            ];

            this.brands.forEach(brand => {
                values.push({
                    value: brand.id,
                    label: brand.feed_name,
                });
            });

            return values;
        },

        categoriesSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_all'), value: null },
            ];

            this.categories.forEach(category => {
                values.push({
                    value: category.id,
                    label: this.connection.configbase === 'feed' ? category.feed_name : this.findCategoryNameById(this.webshopcategories, category.webshop_id),
                });
            });

            return values;
        },

        groupsSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_option'), value: null, disabled: 'disabled' },
            ];

            this.groups.forEach(group => {
                values.push({
                    value: group.id,
                    label: group.name,
                });
            });

            return values;
        },

        combinableValues() {
            const combinable = this.values;

            if (this.search_combinable.length > 0) {
                return combinable.filter(value => value.name.toLowerCase().includes(this.search_combinable.toLowerCase()));
            }

            return combinable;
        },

        uncombinedValues() {
            const combined = [];

            this.values.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (placeholder.value) {
                        if (placeholder.value.length > 0) {
                            combined.push(placeholder.value);
                        }
                    }
                });
            });

            const filtered = this.feedvalues.filter(value => !combined.includes(value.key));

            if (this.search.length > 0) {
                return filtered.filter(value => value.key.toLowerCase().includes(this.search.toLowerCase()));
            }

            return filtered;
        },

        selectedAttribute() {
            if (this.attribute.property_group === null) {
                return false;
                // eslint-disable-next-line
            } else if (this.attribute.property_group == '') {
                return false;
            }
            return true;
        },


    },

};
</script>
<style lang="scss" scoped>
.form-group {
    display: flex;
    align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    .multiselect {
        -webkit-box-flex: 6;
        -ms-flex: 6;
        flex: 6;
        // height: 42px;
        font-size: 16px;
        border: 0;
        background-color: white;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        padding: 0px 16px;
    }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
